/**
 * REACT HOOK - Separate file from pure resolver
 * 
 * React hook wrapper for resolveFieldLabel that automatically gets language.
 * Use this in React components.
 */

import { useLanguage } from "@/i18n/useLanguage";
import { resolveFieldLabel } from "./resolveFieldLabel";
import type { DocFieldSchema } from "@/lib/erp/meta";
import type { ViewMode, ExperienceStyle } from "./types";

/**
 * React hook wrapper for resolveFieldLabel that automatically gets language.
 * Use this in React components.
 * 
 * @example
 * ```tsx
 * const resolveLabel = useResolveFieldLabel();
 * const result = resolveLabel("Item", field, "experience", "shopify");
 * <Label>{result.label}</Label>
 * ```
 */
export function useResolveFieldLabel() {
  const { language } = useLanguage();

  return (
    doctype: string,
    field: DocFieldSchema,
    mode: ViewMode,
    style?: ExperienceStyle,
    enableSystemTranslations?: boolean
  ) => {
    return resolveFieldLabel({
      doctype,
      field,
      mode,
      style,
      language,
      enableSystemTranslations,
    });
  };
}

